import React from 'react';
import { theme } from '../theme';
import { FRIST_GENANNT_WORD } from '../words';
import { InfoTooltip } from './InfoTooltip';
import { pillStyle, INFO_PILL_BORDER_WIDTH } from './SecondaryAxisPills';

// <purpose>THE „Frist genannt" pill on a ticket-list row: the mail names a deadline (the letter
// check's first surviving deadline claim, served as `deadlineQuote`). The info pill's own outline
// (navy-light border at the info tier's width, navy-mid ink) and row metrics; the hover is the
// mail's own words in German quotes.</purpose>
// <constraints>Renders only for a non-empty quote. Every role, no served-vocabulary gate (the check
// runs fleet-wide). The deadline itself lives once in the detail pane's footer check; this pill only
// tells the list that one was named. Adds no row: it joins the row-3 info group.</constraints>
export const FristGenanntPill: React.FC<{ quote: string | null | undefined }> = ({ quote }) => {
  if (!quote || !quote.trim()) return null;
  const pill = (
    <span
      data-testid="frist-genannt-pill"
      style={{
        ...pillStyle('info', 'row'),
        display: 'inline-flex', alignItems: 'center',
        flexShrink: 0, whiteSpace: 'nowrap', fontWeight: 600,
        color: theme.colors.navyMid, backgroundColor: theme.colors.white,
        border: `${INFO_PILL_BORDER_WIDTH} solid ${theme.colors.navyLight}`,
      }}
    >
      {FRIST_GENANNT_WORD}
    </span>
  );
  return <InfoTooltip text={`„${quote.trim()}“`}>{pill}</InfoTooltip>;
};

